exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AgencyServiceList_contactTitle_ybfmq {\n  font-weight: 400;\n  font-size: 14px;\n  margin: 16px 24px 0;\n}\n\n.AgencyServiceList_contactLink_eO_AX {\n  display: block;\n  font-weight: 400;\n  font-size: 13px;\n  margin: 0 24px 16px;\n  color: #4a90e2;\n}\n", ""]);

// exports
exports.locals = {
	"contactTitle": "AgencyServiceList_contactTitle_ybfmq",
	"contactLink": "AgencyServiceList_contactLink_eO_AX"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader!./src/ondemand/components/AgencyServiceList/AgencyServiceList.css
// module id = 1260
// module chunks = 2